import { space } from '@repo/theme/primitives';

export const ENTITY_NODE_HEADER_HEIGHT = 3.75 * space[4];
export const ENTITY_NODE_HEADER_PADDING_X = space[4];
export const ENTITY_NODE_HEADER_PADDING_Y = space[3];
export const ENTITY_NODE_HEADER_INTEGRATION_ICON_SIZE = space[7];
